import type { SVGProps } from 'react';

const SvgPageNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M8 19H7c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h4.2v2.4c0 1.43 1.17 2.6 2.6 2.6H17c.55 0 1-.45 1-1V8c0-.27-.11-.52-.29-.71l-4-4A1 1 0 0 0 13 3H7C5.35 3 4 4.35 4 6v12c0 1.65 1.35 3 3 3h1c.55 0 1-.45 1-1s-.45-1-1-1m7.59-11H13.8c-.33 0-.6-.27-.6-.6V5.61z"
    />
    <path
      fill="currentcolor"
      d="M20 14h-.22l.19-.76a1 1 0 0 0-1.94-.48L17.72 14h-1.94l.19-.76a1 1 0 0 0-1.94-.48L13.72 14H13c-.55 0-1 .45-1 1s.45 1 1 1h.22l-.5 2H12c-.55 0-1 .45-1 1s.45 1 1 1h.22l-.19.76A.995.995 0 0 0 13 22c.45 0 .86-.3.97-.76l.31-1.24h1.94l-.19.76A.995.995 0 0 0 17 22c.45 0 .86-.3.97-.76l.31-1.24H19c.55 0 1-.45 1-1s-.45-1-1-1h-.22l.5-2H20c.55 0 1-.45 1-1s-.45-1-1-1m-3.28 4h-1.94l.5-2h1.94z"
    />
  </svg>
);
export default SvgPageNumber;
